import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { replaceVehicleDataReducers } from './+state';
import { QuickQuoteDataEffects } from './+state/quick-quote-data/quick-quote-data.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('replace-vehicle-data', replaceVehicleDataReducers), // Another store with the name replaceVehicle already exists
    EffectsModule.forFeature([QuickQuoteDataEffects])
  ]
})
export class PolicyReplaceVehicleDataAccessModule {}
